<template>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-lg-12 mt-lg-0 mt-4">
        <h1 class="text-center">Feedback</h1>
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div> 
        <div v-else-if="feedbackList.length === 0" class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
          <p class="text-muted">No feedback received yet.</p>
        </div>
        <div v-for="feedback in feedbackList" v-else :key="feedback.id" class="card mt-4">
          <div class="card-header text-bold d-flex justify-content-between">
            <span>
              {{ feedback.userEmail }}
            </span>
            <span class="d-flex justify-content-end">
              {{ formattedDate(feedback.timestamp) }}
            </span>
          </div>
          <div class="card-body pt-0">
            <p class="text-muted mb-4">{{ feedback.message || 'No feedback provided' }}</p>
          </div>
          <div class="card-footer d-flex justify-content-end">
            <button class="btn btn-danger btn-sm" @click="deleteFeedback(feedback.id)">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchFeedback, deleteFeedback } from '../../services/feedback.service';

export default {
  name: "Feedback",
  data() {
    return {
      isLoading: false,
      feedbackList: []
    };
  },
  async mounted() {
    this.loadFeedbacks();
  },
  methods: {
    async loadFeedbacks() {
      try {
        this.isLoading = true;
        const response = await fetchFeedback();
        this.feedbackList = response.feedback;
      } catch (error) {
        console.error('Error fetching feedback:', error);
      } finally {
        this.isLoading = false;
      }
    },
    formattedDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    async deleteFeedback(id) {
      this.isLoading = true;
      try {
        await deleteFeedback(id);
        this.loadFeedbacks();
      } catch (error) {
        console.error('Error deleting feedback:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
